import {
  CurrencyEnumType,
  initializeUseCurrency,
} from "@ifgengineering/client-invest-sdk";
import { useMemo } from "react";

const useCurrency = (
  currency: CurrencyEnumType = "GBP",
  config?: { noDecimals?: boolean }
) => {
  return useMemo(() => {
    return initializeUseCurrency(currency, config);
  }, [currency, config]);
};

export default useCurrency;
